// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y4-1";
export var printerIcon = "_y4-0";